import React from 'react';
import { Link } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiLink } = FiIcons;

const Layout = ({ children, hideActions = false }) => {
  return (
    <div className="min-h-screen bg-black text-white font-sans selection:bg-red-600 selection:text-white">
      <nav className="border-b border-zinc-800 bg-zinc-950/50 backdrop-blur-md sticky top-0 z-50">
        <div className="max-w-md mx-auto px-4 h-16 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2 group">
            <div className="w-8 h-8 bg-red-600 rounded-lg flex items-center justify-center transform group-hover:rotate-12 transition-transform">
              <SafeIcon icon={FiLink} className="text-white text-xl" />
            </div>
            <span className="font-bold text-lg tracking-tight">
              Connect<span className="text-red-500">Kard</span>
            </span>
          </Link>

          {!hideActions && (
            <div className="flex gap-4 text-sm font-medium text-zinc-400">
              <Link to="/editqr" className="hover:text-red-500 transition-colors">
                Edit Card
              </Link>
            </div>
          )}
        </div>
      </nav>

      <main className="max-w-md mx-auto px-4 py-8 relative">
        {/* Background Ambient Glow */}
        <div className="fixed top-20 left-1/2 -translate-x-1/2 w-64 h-64 bg-red-600/10 rounded-full blur-3xl -z-10 pointer-events-none" />
        {children}
      </main>
    </div>
  );
};

export default Layout;